import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { Accordion, Button, useAccordionButton } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { BsFillGearFill } from 'react-icons/bs';
import { FaBriefcaseMedical, FaBusinessTime, FaStreetView, FaUniversity } from 'react-icons/fa';
import { ImHammer2 } from 'react-icons/im';
import { TbSocial } from 'react-icons/tb';
import './faq.css';




const CustomToggle = ({ children, eventKey }) => {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey);
    const isCurrentEventKey = activeEventKey === eventKey;
    return <button type="button" onClick={decoratedOnClick} aria-expanded={isCurrentEventKey ? true : false} className="edu-accordion-button">{children}</button>
}


export const FAQQQQQ = ({ wrapperClass, admission }) => {
    const [selectedItem, setSelectedItem] = useState();
    const [showtab , setShowtab]=useState(1);
    const handletab =(e)=>{
        setShowtab(e);
    }

   
    return (
        <>

            <div className={` ${wrapperClass ? wrapperClass : ''} `}>
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <ul className="edu-tab-nav nav nav-tabs mt--40">


                                <li className="nav-item" >
                                    <button onClick={()=> handletab(1)}
                                        className={showtab===1 ?'nav-link active' : 'nav-link'}
                                        type="button">
                                        AFTER 12TH/UG
                                    </button>
                                </li>
                                <li className="nav-item" >
                                    <button onClick={()=> handletab(2)}
                                        className={showtab===2 ?'nav-link active' : 'nav-link'}
                                        type="button">
                                        MASTERS
                                    </button>
                                </li>
                                <li className="nav-item" >
                                    <button onClick={()=> handletab(3)}
                                        className={showtab===3 ?'nav-link active' : 'nav-link'}
                                        type="button">
                                        MBA
                                    </button>
                                </li>



                            </ul>
                        </div>

                    </div>
                    <div className={showtab===1 ? 'tab1' : 'tab'}>
                        {admission[0].After12.map((list) =>





                            <div className="row g-5 align-items-center mt--5" >
                                {console.log(list)}
                                <div className="col-lg-6">
                                    <div className="accordion-style-1">

                                        <h6> How to Apply</h6>
                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            <h1 style={{ fontSize: "16px" }}>{list.howToApply} </h1>

                                        </div>

                                        <h6 style={{ marginTop: "15px" }}>  Popular Programs</h6>


                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            {list.PopularPrograms.map((course) => {

                                                return (

                                                    <div className="course-details-two-content">

                                                        <div className="row g-lg-5 g-md-5 g-sm-5">
                                                            <div className="col-lg-12 col-xl-6" style={{ fontSize: "20px" }}>
                                                                <FaBusinessTime /> {course}
                                                            </div>
                                                        </div>
                                                    </div>

                                                )



                                            }


                                            )}


                                        </div>


                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="accordion-style-1">

                                        <h6> Cost Estimate</h6>

                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            <h1 style={{ fontSize: "16px" }}> {list.CostEstimate} </h1>

                                        </div>

                                        <h6 style={{ marginTop: "15px" }}> Popular Universities</h6>
                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>

                                            {list.PopularUniversity.map((uni) => {
                                                return (
                                                    <div className="course-details-two-content">
                                                        {console.log(uni)}
                                                        <div className="row g-lg-5 g-md-5 g-sm-5">
                                                            <div className="col-lg-12 col-xl-6" style={{ fontSize: "20px" }}>
                                                                <FaUniversity /> {uni}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )


                                            })}


                                        </div>


                                    </div>
                                </div>
                            </div>
                            // }

                        )}
                    </div>

                    <div className={showtab===2 ? 'tab1' : 'tab'}>
                        {admission[0].Masters.map((list2) =>


                            <div className="row g-5 align-items-center mt--20">
                                <div className="col-lg-6">
                                    <div className="accordion-style-1">

                                        <h6> How to Apply</h6>
                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            <h1 style={{ fontSize: "16px" }}> {list2.howToApply} </h1>
                                            <div className="course-details-two-content">

                                                <div className="feature-style-6 mt--5">

                                                </div>
                                            </div>
                                        </div>

                                        <h6> Popular Programs</h6>

                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            {list2.PopularPrograms.map((course) => {

                                                return (

                                                    <div className="course-details-two-content">

                                                        <div className="row g-lg-5 g-md-5 g-sm-5">
                                                            <div className="col-lg-12 col-xl-6" style={{ fontSize: "20px" }}>
                                                                <FaBusinessTime /> {course}
                                                            </div>
                                                        </div>
                                                    </div>

                                                )



                                            }


                                            )}


                                        </div>


                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="accordion-style-1">

                                        <h6> Cost Estimate</h6>

                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            <h1 style={{ fontSize: "16px" }}> {list2.CostEstimate}</h1>
                                            <div className="course-details-two-content">

                                                <div className="feature-style-6 mt--5">

                                                </div>
                                            </div>
                                        </div>

                                        <h6> Popular Universities</h6>
                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>

                                            {list2.PopularUniversity.map((uni) => {
                                                return (
                                                    <div className="course-details-two-content">
                                                        {console.log(uni)}
                                                        <div className="row g-lg-5 g-md-5 g-sm-5">
                                                            <div className="col-lg-12 col-xl-6" style={{ fontSize: "20px" }}>
                                                                <FaUniversity /> {uni}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )


                                            })}


                                        </div>


                                    </div>
                                </div>
                            </div>
                        )}
                   </div>
                    <div className={showtab===3 ? 'tab1' : 'tab'}>
                        {admission[0].Masters.map((list3) =>

                            <div className="row g-5 align-items-center mt--20">
                                <div className="col-lg-6">
                                    <div className="accordion-style-1">

                                        <h6> How to Apply</h6>
                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            <h1 style={{ fontSize: "16px" }}> {list3.howToApply} </h1>
                                            <div className="course-details-two-content">

                                                <div className="feature-style-6 mt--5">

                                                </div>
                                            </div>
                                        </div>

                                        <h6> Popular Programs</h6>

                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            {list3.PopularPrograms.map((course) => {

                                                return (

                                                    <div className="course-details-two-content">

                                                        <div className="row g-lg-5 g-md-5 g-sm-5">
                                                            <div className="col-lg-12 col-xl-6" style={{ fontSize: "20px" }}>
                                                                <FaBusinessTime /> {course}
                                                            </div>
                                                        </div>
                                                    </div>

                                                )



                                            }


                                            )}


                                        </div>


                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="accordion-style-1">

                                        <h6> Cost Estimate</h6>

                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>
                                            <h1 style={{ fontSize: "16px" }}>{list3.CostEstimate}</h1>
                                            <div className="course-details-two-content">

                                                <div className="feature-style-6 mt--5">

                                                </div>
                                            </div>
                                        </div>

                                        <h6> Popular Universities</h6>
                                        <div className="course-details-card mt--5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.12", border: "2px solid #eaeaea" }}>

                                            {list3.PopularUniversity.map((uni) => {
                                                return (
                                                    <div className="course-details-two-content">
                                                        {console.log(uni)}
                                                        <div className="row g-lg-5 g-md-5 g-sm-5">
                                                            <div className="col-lg-12 col-xl-6" style={{ fontSize: "20px" }}>
                                                                <FaUniversity /> {uni}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )


                                            })}


                                        </div>


                                    </div>
                                </div>
                            </div>

                        )}
                    </div>

                </div>
            </div>
        </>
    )
}
